module.exports = __webpack_public_path__ + "img/hotelBanner.51cd78cb.png";